module.exports = __webpack_public_path__ + "img/square_green.42d7fb5d.svg";